module.exports = __webpack_public_path__ + "img/si.6e20dab7.svg";